import * as React from 'react';
export const DialogContext = React.createContext(void 0);
export const useDialogContext = () => React.useContext(DialogContext) || {};
